import { useCallback } from "react";

import { modules, useObjectMemo } from "byzantine";
import { useNavigate } from "react-router-dom";

export const useTemplateSelector = () => {
  const {
    sortedFedwireTemplateIds,
    showManageTemplatesUI,
    selectedTemplateId,
    onSelectTemplate,
    method,
    error,
  } = modules.wireTemplates.useTemplateSelector();
  const navigate = useNavigate();

  const manageTemplates = useCallback(() => {
    navigate("/templates/wire?from=template-selector");
  }, [navigate]);

  return useObjectMemo({
    showManageTemplatesUI,
    sortedFedwireTemplateIds,
    selectedTemplateId,
    onSelectTemplate,
    manageTemplates,
    method,
    error,
  });
};
